// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3AmTo","filesListContainer":"PosDisputesFiles_filesListContainer__3dbzg","filesButton":"PosDisputesFiles_filesButton__-cs42"};